/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import { useFormatStatusEventDateTime } from '../useFormatStatusEventDateTime';

const { Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const UnloadingPointMobile = ({
  className,
  deliveryAddress,
  mapsDirectionsHref,
  siteContact,
  ticket,
  unloading,
  arriveJob,
  endUnloading,
  isStandAloneTicket,
}) => {
  const formatTicketDateTime = useFormatStatusEventDateTime({ mode: 'datetime' });

  return (
    <Styled className={cn('unloading-point', className)}>
      <Subtitle>
        <Translate stringId="unloadingPoint" data-testid="unloadingPointLabel" />
      </Subtitle>
      <div className="label">
        <Translate stringId="siteAddress" data-testid="siteAddressLabel" />:{' '}
      </div>
      <span data-testid="deliveryAddressValue">{deliveryAddress}</span>{' '}
      {mapsDirectionsHref && isStandAloneTicket && (
        <a
          href={mapsDirectionsHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="getDirectionsLink"
        >
          <Translate stringId="getDirections" data-testid="getDirectionsLabel" />
        </a>
      )}
      <div className="label">
        <Translate stringId="customer" data-testid="customerLabel" />:{' '}
      </div>
      <span data-testid="customerName">
        {ticket?.customerParty?.id}/{ticket?.customerParty?.name}
      </span>
      <div className="label">
        <Translate stringId="siteContactName" data-testid="siteContactNameLabel" />:{' '}
      </div>
      <span data-testid="siteContactName">{siteContact?.name}</span>
      <div className="label">
        <Translate stringId="siteContactPhoneNumber" data-testid="customerPhoneNumberLabel" />:{' '}
      </div>
      <span data-testid="customerPhoneNumber">
        {' '}
        <a href={`tel:${siteContact?.phone}`}>{siteContact?.phone}</a>{' '}
      </span>
      {ticket?.customData?.ticketType !== 'PMP' && (
        <div>
          <div className="label">
            <Translate stringId="unloadingScheduleStart" data-testid="unloadingScheduleStartLabel" />
            {': '}
          </div>
          <span style={{ whiteSpace: 'nowrap' }} data-testid="unloadingScheduleStart">
            {formatTicketDateTime(unloading)}
          </span>
        </div>
      )}
      <div className="label">
        <Translate stringId="agreedUnloading" data-testid="agreedUnloadingLabel" />
        {': '}
      </div>
      <span style={{ whiteSpace: 'nowrap' }} data-testid="agreedUnloading">
        {formatTicketDateTime(arriveJob)}
        {' - '}
      </span>
      <span>{formatTicketDateTime(endUnloading)}</span>
    </Styled>
  );
};

export default UnloadingPointMobile;
